import {FC} from "react";
import React from "react";
import Chatbot from "./Chatbot/Chatbot";


interface Props {
    children: React.ReactNode;
}

const Layout:FC<Props>=({children}) => {
    return (
        <div className="layout">
            <div className="main-container">
                {children}
            </div>
            <Chatbot />
        </div>
    )
}
export default Layout